G.OMTsettingsDefault = {
  /* configuration for Delta DNA, comment out block or remove to disable */
  /*
  DDNA: { 
    collect: "https://collect15042cndyr.deltadna.net/collect/api/", 
    engage: "https://engage15042cndyr.deltadna.net/", 
    env: G.BuildEnvironment.production ? "99892253560587544228437458715538" : "99892245470978161777838279315538",
    queueInterval: 10000,
    ftuxVersion : 1 // this should be a integer
  },
  */
  shoutouts: {
    amountTier0: 3,
    amountTier1: 2,
  },

  // ===================================================================
  global: {
    defaultFont: 'Baloo-Regular',
    leaderboardName: 'completedLevels',
    window: {
      title: {
        textStyle: {
          style: "font-white",
          fontSize: "72px",
          align: "center",
        },
      },
      mediumTitle: {
        textStyle: {
          style: "font-white",
          fontSize: "60px",
          align: "center",
        },
      },
      smallTitle: {
        textStyle: {
          style: "font-white",
          fontSize: "50px",
          align: "center",
        },
      },
    },
    popUpFlexBg: {
      width: 582,
      bottomBgHeight: 333,
    },
  },

  elements: {
    leaderboard: {
      tabLivesSelected: false,
    },
    gingy: {
      backEyes: {
        x: 0,
        y: -115,
      },
      eyes: {
        x: 7,
        y: -121,
      },
      eyelids: {
        x: 6,
        y: -121
      },
      mouth: {
        x: 11,
        y: -80,
      },
    },
    tutorialMsg: {
      fontSize: 45,
      lineSpacing: -17,
    },
    dailyReward: {
      title: {
        x: 0,
        y: -285,
        style: {
          fill: 'white',
          font: G.Text.defaultFont,
          fontSize: '55px',
        },
      },
      comeBackTxt: {
        lineSpacing: -20,
      },
    },
    dailyIcon: {
      unlockTxt: {
        x: 0,
        y: 0,
        fontSize: '30px',
      },
      adIcon: {
        x: 20,
        y: 20,
      },
      glow: {
        x: 0,
        y: 0,
      },
      timer: {
        x: 0,
        y: 7,
      },
      icon: {
        x: 0,
        y: 0,
      },
      freeText: {
        x: 0,
        y: 0,
        shadow: {
          x: 0,
          y: 0,
        },
      },
      xCenterOffset: 260,
      x: 855,
      y: 140,
    },
    dailyChallengeIcon: {
      icon: {
        x: 0,
        y: 0,
      },
      adIcon: {
        x: 20,
        y: 20,
      },
      xShift: 0,
      xCenterOffset: -265,
      x: 855,
      y: 300,
    },
    dailyMission: {
      ribbonText: {
        yPos: 0, // unset it?
      },
    },
    giftUI: {
      sideGingy: {
        txtBg: {
          scale: {
            x: 0.9,
            y: 0.8,
          },
        },
        txt: {
          lineSpacing: 0,
          fontSize: '60px',
        },
      },
    },
    worldSidePanelLockedWidget: {
      unlockTxt: {
        fontSize: '30px',
      },
    },
    highscoreBeaten: {
      continueBtn: {
        x: 0,
        y: 245,
      },
    },
    checkedIconPast: {
      x: 35,
      y: 15,
    },
    checkedIcon: {
      x: 35,
      y: 15,
    },
    mapGift: {
      btn: {
        x: 3,
        y: 0,
      },
      timer: {
        x: 0,
        y: 55,
      },
      xCenterOffset: 260,
      y: 0,
    },
    worldMapLvlButton: {
      lvlNrText: {
        style: {
          style: "font-white",
          fontSize: "50px",
        },
      },
    },
    UI_MapPanel: {
      starsIcon: {
        x: 0,
        y: 36,
      },
      starsTxt: {
        x: -240,
        y: 43,
        style: {
          style: "font-white",
          fontSize: "35px",
        },
      },
      coinsBg: {
        x: 0,
        y: 37,
      },
      coinsTxt: {
        x: -40,
        y: 43,
        style: {
          style: "font-white",
          fontSize: "35px",
        },
      },
      plusIcon: {
        x: 210,
        y: 37,
      },
      moveTo: {
        ifLifes: {
          stars: -90,
          coins: 120,
        },
        ifNotLifes: {
          stars: -270,
          coins: -50,
        },
      },
      settingsMenu: {
        x: 280,
        y: 38,
        scale: 1,
      },
    },
    Window_friendOvertaken: {
      titleTxt: {
        style: {
          style: "font-white",
          fontSize: "60px",
        },
      },
    },
    Window_popupOffer: {
      headerOffset: 0,
    },
    Window_highscoreBeaten: {
      titleTxt: {
        style: {
          style: "font-white",
          fontSize: "60px",
        },
      },
    },
    Window_crossPromo: {
      titleTxt: {
        x: 0,
        y: -272,
        style: {
          style: "font-white",
          fontSize: "60px",
        },
      },
      continueBtn: {
        x: 0,
        y: 245,
      },
      continueBtnTxt: {
        x: 0,
        y: 0,
        style: {
          style: "font-white",
          fontSize: "40px",
          lineSpacing: -15
        },
      },
    },
    Window_giveUp: {
      levelTxt: {
        style: {
          style: "font-white",
          fontSize: "60px",
        },
      },
    },
    Window_botOptIn: {
      titleTxt: {
        style: {
          style: "font-white",
          fontSize: "60px"
        },
      },
    },
    unlimitedLivesMinDefaultReward: 15,
    Window_notEnoughLives: {
      livesNrTxt: {
        x: 0,
        y: -60,
      },
      coinsTxt: {
        x: 10,
        y: -279,
        style: {
          style: "font-white",
          fontSize: "35px",
        },
      },
      buyLifeButton_coinTxt: {
        style: {
          style: "font-white",
          fontSize: "40px"
        }
      }
    },
    Window_taskSlider: {
      taskTxt: {
        y: 45,
        style: {
          style: "font-purple",
          fontSize: "32px"
        },
      },
      goal: {
        style: {
          style: "font-purple",
          fontSize: "50px",
        },
      },
    },
    Window_newsHomeScreen: {
      button: {
        shouldPulse: false,
        x: 0,
        y: 285,
      },
      continueBtn: {
        x: 0,
        y: 300,
      },
      continueBtnTxt: {
        x: 0,
        y: 300,
      },
    },
    Window_treasureHuntEvent: {
      bgSize: 240,
    },
    Window_FortuneCookie: {
      avatarLayout: {
        funny: {
          x: -88,
          y: -10,
          angle: -5,
        },
        prediction: {
          x: -3,
          y: -24,
          angle: 0,
        },
        love: {
          x: -60,
          y: -6,
          angle: 3,
        },
        wisdom: {
          x: 76,
          y: 11,
          angle: 0,
        },
        game: {
          x: 20,
          y: -22,
          angle: 15,
        },
      },
    },
    UI_Life: {
      livesNrTxt: {
        x: 0,
        y: 0,
      },
      timerTxt: {
        x: 85,
        y: 7,
        style: {
          style: "font-white",
          fontSize: "35px",
        },
      },
      unlimitedTimerTxt: {
        x: 85,
        y: 7,
        style: {
          style: "font-white",
          fontSize: "35px",
          stroke: "#a41d02",
          strokeThickness: 5,
        },
      },
      timerMaxTxt: {
        x: 80,
        y: 7,
        style: {
          style: "font-white",
          fontSize: "35px",
        },
      },
    },
    UI_PointsCounter: {
      text: {
        style: {
          style: "font-white",
          fontSize: "35px",
        },
      },
    },
    UI_BoosterButton: {
      amount: {
        style: {
          style: "font-purple",
          fontSize: "25px",
        },
      },
    },
    UI_StartBoosterButton: {
      amountTxt: {
        style: {
          style: "font-purple",
          fontSize: "25px",
        },
      },
    },
    taskCollectPanels: {
      amount: {
        style: {
          style: "font-purple",
          fontSize: "50px",
        },
      },
    },
    UI_GoalPanelCollect: {
      panelNr: {
        style: {
          style: "font-purple",
          fontSize: "60px",
        },
      },
    },
    UI_GoalPanelPoints: {
      labelTxt: {
        style: {
          style: "font-purple",
          fontSize: "40px",
        },
      },
      pointsCounter: {
        style: {
          style: "font-purple",
          fontSize: "40px",
        },
      },
    },
    UI_TopBar: {
      movesTxt: {
        style: {
          style: "font-purple",
          fontSize: "25px",
        },
      },
      movesAmountTxt: {
        style: {
          style: "font-purple",
          fontSize: "30px",
        },
      },
    },
    gifts: {
      // whether we open gift by hiding lid or with two-frame animation
      twoFrameOpen: false,
      shineOffsetX: 0,
      shineOffsetY: 0,
    },
    // these colors use { GIFT_COLORS } from "../../js/Elements/Windows/GiftUI/GiftGraphic"
    dailyRewardCalendar: {
      doubleable: true,
      days: [
        {
          gifts: [['coin', 200]],
          boxIcon: [],
        },

        {
          gifts: [['booster#2', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Green',
              ribbonTint: 'Red',
              pos: [0, 0],
            },
          ],
        },

        {
          gifts: [['booster#7', 1]],
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Pink',
              ribbonTint: 'Light_Blue',
              pos: [-10, 0],
            },
            {
              giftType: 1,
              boxTint: 'Teal',
              ribbonTint: 'Red',
              pos: [25, 15],
              scale: [0.75, 0.75],
            },
          ],
        },

        {
          gifts: [['booster#5', 1]], // #5/#6 fixed in dailyRewardMgr
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Purple',
              ribbonTint: 'Red',
              pos: [0, 0],
            },
            {
              giftType: 1,
              boxTint: 'Light_Blue',
              ribbonTint: 'Red',
              pos: [-30, 20],
              scale: [0.6, 0.6],
            },
            {
              giftType: 1,
              boxTint: 'Green',
              ribbonTint: 'Orange',
              pos: [30, 20],
              scale: [0.6, 0.6],
            },
          ],
        },

        {
          gifts: [['booster#1', 1]],
          boxIcon: [
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Red',
              pos: [20, 0],
            },
            {
              giftType: 1,
              boxTint: 'Light_Blue',
              ribbonTint: 'Orange',
              pos: [-30, 12],
              scale: [0.75, 0.75],
            },
            {
              giftType: 2,
              boxTint: 'Red',
              ribbonTint: 'Dark_Blue',
              pos: [0, 25],
              scale: [0.55, 0.55],
            },
          ],
        },

        {
          gifts: [['booster#8', 1]],
          boxIcon: [
            {
              giftType: 1,
              boxTint: 'Red',
              ribbonTint: 'Dark_Blue',
              pos: [20, 0],
            },
            {
              giftType: 2,
              boxTint: 'Green',
              ribbonTint: 'Red',
              pos: [-25, 5],
              scale: [0.8, 0.8],
            },
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Red',
              pos: [0, 25],
              scale: [0.5, 0.5],
            },
          ],
        },

        {
          gifts: [
            ['booster#5', 1], // #5/#6 fixed in dailyRewardMgr
            ['booster#8', 1],
          ],
          boxIcon: [
            // leftmost
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Pink',
              pos: [-70, 0],
              scale: [0.7, 0.7],
            },
            // second from right
            {
              giftType: 1,
              ribbonTint: 'Dark_Blue',
              boxTint: 'Pink',
              pos: [55, -10],
              scale: [0.9, 0.9],
            },
            // center
            {
              giftType: 2,
              boxTint: 'Green',
              ribbonTint: 'Red',
              pos: [0, 0],
              scale: [1, 1],
            },
            // second frm left
            {
              giftType: 1,
              boxTint: 'Dark_Blue',
              ribbonTint: 'Orange',
              pos: [-40, 20],
              scale: [0.7, 0.7],
            },
            // rightmost
            {
              giftType: 2,
              boxTint: 'Teal',
              ribbonTint: 'Red',
              pos: [80, 10],
              scale: [0.6, 0.6],
            },
          ],
        },
      ],
    },
  },

  // ===================================================================
};
